import React, {useEffect, useMemo, useState} from "react";
import * as webSocket from "@tools/webSocket/webSocket";

import { Alert } from "antd";
import { useTranslation } from "react-i18next";

const SystemMessages: React.FC = () => {
    const [messageType, setMessageType] = useState("")
    const {t} = useTranslation()

    useEffect(() => {
        const ev = webSocket.on("message", data => {
            const {type} = data
            if(type === "systemMessage"){
                setMessageType(data.data.event)
            }
        })

        return () => {ev.off()}
    }, [])

    const alertType = useMemo(() => {
        switch(messageType){
            case "startBuild":
                return "warning"
            case "startDbUpdate":
            case "restartingServer":
                return "error"
            default:
                return "success"
        }
    }, [messageType])

   return <div style={{flex: "1 1 auto"}}>
           {messageType && <Alert showIcon type={alertType as any} message={t(`systemMessages:${messageType}`)} style={{margin: "0 10px", height: 32, overflowY: "auto", lineHeight: "12px", fontSize: "10px"}}/>}
       </div>

}

export default SystemMessages
